import { cleanUpBillingsList, getBillingsListThunk } from "../../../reducers/billingsReducer";
import { AppDispatch } from "../../../store";

export const resetBillingList = (dispatch: AppDispatch): void => {
  dispatch(cleanUpBillingsList());
  dispatch(getBillingsListThunk());
};
